import API_BASE_URL from "./RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/ticketing`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

export const sprintExportApi = {
    // The sprint's release sheet (.xlsx) as a Blob. Failures come back as the
    // usual JSON envelope, so surface its message.
    exportSprint: async (sprintId) => {
        const res = await fetch(`${BASE}/sprint/export/?sprint_id=${sprintId}`, { headers: getAuthHeaders() });
        if (!res.ok || (res.headers.get("Content-Type") || "").includes("application/json")) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body.message || "Failed to export the sprint");
        }
        return res.blob();
    },
};